<template>
  <footer class="waitlist-footer">
    <div class="footer-container">
      <div class="footer-content">
        <div class="footer-copyright">
          <span class="copyright-text">© 2026 Tern Travel Inc</span>
        </div>
        <div class="footer-social-links">
          <a
            target="_blank"
            href="https://www.instagram.com/heytilly.ai"
            class="social-link"
            aria-label="Instagram"
            rel="noopener noreferrer"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.946 5.33081C7.84058 5.33081 5.33569 7.83569 5.33569 10.9412C5.33569 14.0466 7.84058 16.5515 10.946 16.5515C14.0515 16.5515 16.5564 14.0466 16.5564 10.9412C16.5564 7.83569 14.0515 5.33081 10.946 5.33081ZM10.946 14.5886C8.93921 14.5886 7.29858 12.9529 7.29858 10.9412C7.29858 8.92944 8.93433 7.2937 10.946 7.2937C12.9578 7.2937 14.5935 8.92944 14.5935 10.9412C14.5935 12.9529 12.9529 14.5886 10.946 14.5886ZM18.0945 5.10132C18.0945 5.82886 17.5085 6.40991 16.7859 6.40991C16.0584 6.40991 15.4773 5.82397 15.4773 5.10132C15.4773 4.37866 16.0632 3.79272 16.7859 3.79272C17.5085 3.79272 18.0945 4.37866 18.0945 5.10132ZM21.8103 6.42944C21.7273 4.67651 21.3269 3.12378 20.0427 1.84448C18.7634 0.565185 17.2107 0.164795 15.4578 0.0769043C13.6511 -0.0256348 8.23608 -0.0256348 6.42944 0.0769043C4.6814 0.159912 3.12866 0.560303 1.84448 1.8396C0.560303 3.1189 0.164795 4.67163 0.0769043 6.42456C-0.0256348 8.2312 -0.0256348 13.6462 0.0769043 15.4529C0.159912 17.2058 0.560303 18.7585 1.84448 20.0378C3.12866 21.3171 4.67651 21.7175 6.42944 21.8054C8.23608 21.908 13.6511 21.908 15.4578 21.8054C17.2107 21.7224 18.7634 21.322 20.0427 20.0378C21.322 18.7585 21.7224 17.2058 21.8103 15.4529C21.9128 13.6462 21.9128 8.23608 21.8103 6.42944ZM19.4763 17.3914C19.0955 18.3484 18.3582 19.0857 17.3962 19.4714C15.9558 20.0427 12.5378 19.9109 10.946 19.9109C9.35425 19.9109 5.9314 20.0378 4.49585 19.4714C3.53882 19.0906 2.80151 18.3533 2.41577 17.3914C1.84448 15.9509 1.97632 12.533 1.97632 10.9412C1.97632 9.34937 1.84937 5.92651 2.41577 4.49097C2.79663 3.53394 3.53394 2.79663 4.49585 2.41089C5.93628 1.8396 9.35425 1.97144 10.946 1.97144C12.5378 1.97144 15.9607 1.84448 17.3962 2.41089C18.3533 2.79175 19.0906 3.52905 19.4763 4.49097C20.0476 5.9314 19.9158 9.34937 19.9158 10.9412C19.9158 12.533 20.0476 15.9558 19.4763 17.3914Z"
                fill="currentColor"
              />
            </svg>
          </a>
          <a
            target="_blank"
            href="https://substack.com/@heytillyai"
            class="social-link"
            aria-label="Substack"
            rel="noopener noreferrer"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z"
              />
            </svg>
          </a>
          <a
            target="_blank"
            href="http://tiktok.com/@heytilly.ai"
            class="social-link"
            aria-label="TikTok"
            rel="noopener noreferrer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 448 512"
              fill="currentColor"
            >
              <path
                d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
              />
            </svg>
          </a>
          <a
            target="_blank"
            href="https://www.x.com/heytilly_ai"
            class="social-link"
            aria-label="Twitter"
            rel="noopener noreferrer"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 26 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.567383 0L9.66262 14.0842L1.04555 25H4.43029L11.1772 16.4307L16.71 25H25.5674L16.0541 10.2431L24.1179 0H20.7857L14.5445 7.89931L9.45232 0H0.567383ZM5.48927 2.77778H8.11545L20.648 22.2222H18.0444L5.48927 2.77778Z"
                fill="currentColor"
              />
            </svg>
          </a>
          <a
            target="_blank"
            href="https://www.linkedin.com/company/heytillyai"
            class="social-link"
            aria-label="LinkedIn"
            rel="noopener noreferrer"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                fill="currentColor"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'WaitlistFooter',
};
</script>

<style scoped>
.waitlist-footer {
  background: #ffffff;
  border-top: 0.5px solid rgba(0, 0, 0, 0.08);
  padding: 0;
  position: relative;
  overflow: hidden;
}

.waitlist-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(0, 0, 0, 0.05) 50%,
    transparent 100%
  );
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 2rem;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
}

.footer-copyright {
  order: 2;
}

.copyright-text {
  font-size: 0.6875rem;
  line-height: 1.5;
  color: #86868b;
  font-weight: 400;
  letter-spacing: -0.01em;
  text-align: center;
  display: block;
  transition: color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.footer-social-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.75rem;
  order: 1;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: #86868b;
  cursor: pointer;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 50%;
}

.social-link::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0);
  transition: background 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.social-link:hover::before {
  background: rgba(0, 0, 0, 0.04);
}

.social-link:hover {
  color: #1d1d1f;
  transform: translateY(-1px);
}

.social-link:active {
  transform: translateY(0);
}

.social-link svg {
  position: relative;
  z-index: 1;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.social-link:hover svg {
  transform: scale(1.05);
}

/* Desktop styles */
@media (min-width: 768px) {
  .footer-container {
    padding: 3.5rem 2.5rem;
  }

  .footer-content {
    flex-direction: row;
    gap: 0;
  }

  .footer-copyright {
    order: 1;
  }

  .copyright-text {
    text-align: left;
    font-size: 0.75rem;
  }

  .footer-social-links {
    order: 2;
    gap: 2rem;
  }

  .social-link {
    width: 36px;
    height: 36px;
  }
}

/* Large desktop */
@media (min-width: 1024px) {
  .footer-container {
    padding: 4rem 3rem;
  }
}

/* Smooth animations */
@media (prefers-reduced-motion: no-preference) {
  .social-link {
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .copyright-text {
    transition: color 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  }
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .social-link,
  .social-link svg,
  .copyright-text {
    transition: none;
  }
}
</style>
